var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuth)?_c('div'):_c('div',[_c('PageRenderer',{attrs:{"chimera-options":_vm.landingPageOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }